import { PREDEFINED_SWATCH_COLORS } from "./../../../../../plugin-button/defaults.js";
const removeColorDuplicates = (themeColorsProp, customColorsProp) => {
  const ignoredCustomColors = [...PREDEFINED_SWATCH_COLORS, ...themeColorsProp];
  const adjustedCustomColors = customColorsProp.filter(
    (color) => !ignoredCustomColors.includes(color)
  );
  return {
    themeColors: themeColorsProp,
    customColors: adjustedCustomColors
  };
};
export {
  removeColorDuplicates
};
//# sourceMappingURL=utils.js.map
